// Generated by ts-to-zod
import { z } from 'zod';

export const emailTemplateStatsListQuerySchema = z.object({
  queue: z.number().optional(),
  pageSize: z.number().optional(),
  page: z.number().optional(),
});
